import { Box, Button, TextField } from '@mui/material'
import { useEffect, useState } from 'react';
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon';
import { rqx } from '../../../../../core/request/API';
import { env } from '../../../../../core/Env';
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader';
import { CreateFeatureLogs } from '../../../../../core/request/Global';
import { FeatureIdState } from '../../../toolUsage/global/GlobalFcn';
export const Pretest = ({openWidth, wideHandler, information_state, uid, nav, tool_state}) => {
    const [ans, setAns] = useState([])
    const [act, setAct] = useState(false)
    const [selectCategory, setselectCategory] = useState([])
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [validationError, setValidationError] = useState('');
    const [modeOfConduct, setModeOfConduct] = useState(null);
    let urlParams = new URLSearchParams(window.location.search);
    
    useEffect(() => {
        information_state.test.set({...information_state.test.data, name:'Pretest'})
        const __init = async()=> {
            const init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_pretest`, {training_id:urlParams.get('id'), ref:'trainings'})
            const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {training_id:urlParams.get('id'), user_id: uid, ref:'trainings', company_id: tool_state.cinfo.data[0].company_id  })
            const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {training_id:urlParams.get('id'), ref:'trainings', company_id: tool_state.cinfo.data[0].company_id})
            const updatedProg = { pretest: 0, vl: 0, quiz: 0, posteval: 0 };
            progress.forEach(item => {
                if (item.exam_type === 1) {
                // pretest
                updatedProg.pretest = item.exam_type === 1 ? 1 : 0;
                } else if (item.exam_type === 2) {
                // quiz
                updatedProg.quiz = item.exam_type === 2 ? 1 : 0;
                } else if (item.exam_type === 3) {
                // post eval
                updatedProg.posteval = item.exam_type === 3 ? 1 : 0;
                } else if (item.exam_type === 4) {
                // video Lesson
                updatedProg.vl = item.exam_type === 4 ? 1 : 0;
                }
            });
            information_state.prog.set(updatedProg)
            setModeOfConduct(tContent[0].mode_of_conduct)
            information_state.tc.set({...information_state.tc.data, pretest:tContent[0].pretest_id !== null ? 1 : null, quiz:tContent[0].quiz_id !== null? 1: null, posteval:tContent[0].post_evaluation_id !== null ? 1 : null})
            information_state.exam.set(init)
        }
        __init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const handleChange =(e, id, question, k) => {
        const userAnswer = e.target.value.trim();
        const answerStatus = userAnswer !== '' ? 1 : 0;
        let newAns = [...ans];
        newAns[k] = { question_id: id, question: question, ans: e.target.value, answer_status: answerStatus };
        setAns(newAns);

        let newSelectCategory = [...selectCategory];
        newSelectCategory[k] = k;
        setselectCategory(newSelectCategory);

        let err = [...validationError]
        err[k] = false
        setValidationError(err)
        if (!newAns[k]) {
            setCorrectAnswers((prevCount) => prevCount + 1);
        }
    }
    const handleClick = (e, id, q, k, kk, choice, correct) => {
        e.preventDefault()
        if (act !== true) {
            const isCorrect = correct === choice ? 1 : 0 
            let a = [...ans]
            a[k] = {question_id: id, question: q, ans: choice, answer_status: isCorrect }
            setAns(a)
            let b = [...selectCategory]
            b[k] = kk
            setselectCategory(b)
            let err = [...validationError]
            err[k] = false
            setValidationError(err)
            if(correct === choice) {
                setCorrectAnswers((prevCount)=> prevCount + 1)
            }
        }
    }

    const handleSubmit = () => {
        const correctCount = ans.filter(a => a && a.answer_status === 1).length;
        setCorrectAnswers(correctCount);
        const allAnsweredStatus = information_state.exam.data.exam.map((q, k) => {
            if (ans[k] && ans[k].ans !== '') {
                return false;
            } else {
                return true;
            }
        });
        
        if (allAnsweredStatus.includes(true)) {
            setValidationError(allAnsweredStatus);
            return;
        } else {
            setValidationError(allAnsweredStatus);
        }
        
        const data ={
          user_id:uid,
          exam_type:1,
          progress_status:1,
          training_id:urlParams.get('id'),
          data:ans,
          company_id: tool_state.cinfo.data[0].company_id
        }
        _init(data)
        
    }
    
    const _init = async(data)=>{
        // eslint-disable-next-line
        let res = { 
            aid: tool_state.__SESSION.data.ainfo.aid,
            path: `${FeatureIdState('assessment')}->1`,
            feature_id: FeatureIdState('assessment'),
            feature_name: 'assessment-pretest',
            tid: parseInt(process.env.REACT_APP_TID_BIZ),
            company_id: tool_state.cinfo.data[0].company_id,
            action: 1,
        } 
        await CreateFeatureLogs(res)
        await rqx.post(`<<tool>>/${env()}/biz_exam/user_update_status`, data)
        const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_create`, data)
        if (init.message === 'success') {
            setAct(true)
        } else if (init.message === 'proceed') {
            // console.log('error')
            setAct(true)
        } else {
            console.log('error')
            // setAct(true)
        }
    }

    const handleProceed = () => {
        if(modeOfConduct === 2){
            nav.push(`/biz/take-training/quiz?id=${urlParams.get('id')}`)
        } else {
            nav.push(`/biz/take-training/video-lesson?id=${urlParams.get('id')}`)
        }
    }

    return (
        <Box p="40px" display="flex" flexDirection="column" width="100%" height="100%">
            <Box width="100%" height="100%">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box fontSize={14} fontWeight={400} lineHeight="22.65px">Direction: Choose the letter of the correct answer.</Box>
                    { !openWidth.data && (
                        <Box display="flex" className='c-pointer' onClick={wideHandler}>
                            <MenuIcon />
                            <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Show menu</Box>
                        </Box>
                        )
                    }
                </Box>
                { act === true && (
                    <Box border="1px solid #E5EBF6" bgcolor="#1893F1" borderRadius="8px" p="24px 16px 24px 16px" mt="24px" width="100%">
                        <Box fontSize={14} fontWeight={400} lineHeight="23px" color="#E3F2FD">You have reached {correctAnswers} of {information_state.exam.data.length} point(s), ({parseFloat(correctAnswers/(information_state.exam.data.exam.length/100).toFixed(2))}%)</Box>
                    </Box>
                )}
                { information_state.exam.data !== undefined ? (
                        information_state.exam.data.exam.map((q, k) => (
                            <Box key={k} border="1px solid #E5EBF6" borderRadius="6px" p="24px" mt="24px" width="100%">
                                <Box fontSize={14} fontWeight={600} lineHeight="22px">Question no. {k + 1}</Box>
                                <Box fontSize={14} fontWeight={400} lineHeight="22px" mt="24px" mb="8px">{q.question}</Box>
                                { 
                                    q.type === 2 ? (
                                        <Box component={TextField} multiline  maxRows={4} borderColor="#E5EBF6" bgcolor="#F5F8FF" width="100%" mt="16px" onChange={(e)=>handleChange(e, q.question_id, q.question, k)} value={ans[k]?.ans || ''} error={validationError[k]} />
                                    ) : (
                                        q.choices.map((v, kk)=>(
                                            <Box key={kk} display='flex' width="100%" mt="16px" onClick={(e)=>handleClick(e, q.question_id, q.question, k, kk, v.key, q.correct)} >
                                                <Box display="flex" alignItems="center" width="100%" sx={{textAlign: 'start', '&:hover': {'& > div:first-of-type': {bgcolor: '#E3F2FD',}, },}}>
                                                    <Box border={validationError[k] === true? "1px solid #FF0000" : "1px solid #E5EBF6"} borderRadius="100%" bgcolor= { act === false ? (selectCategory[k] === kk && '#E3F2FD') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#E8F5E9' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FFEBEE' : ( q.correct === v.key && '#E8F5E9' ) ) )}  color= { act === false ? (selectCategory[k] === kk && '#1893F1') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#008F5D' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FA3E3E' : ( q.correct === v.key && '#008F5D' ) ) ) } p="8px 12px 8px 12px" >
                                                        <Box fontSize={14} fontWeight={600}>{v.key}</Box>
                                                    </Box>
                                                    <Box border={validationError[k] === true? "1px solid #FF0000" : "1px solid #E5EBF6"} borderRadius="6px" bgcolor= { act === false ? (selectCategory[k] === kk && '#E3F2FD') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#E8F5E9' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FFEBEE' : ( q.correct === v.key && '#E8F5E9' ) ) )}  color= { act === false ? (selectCategory[k] === kk && '#1893F1') : ( selectCategory[k] === kk && q.correct === ans[k].ans ? '#008F5D' : ( selectCategory[k] === kk && q.correct !== ans[k].ans ? '#FA3E3E' : ( q.correct === v.key && '#008F5D' ) ) ) }  className='choices' p="12px" width="100%" ml="16px" >
                                                        <Box fontSize={14} fontWeight={600}>{v.value}</Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ))
                                    )
                                }
                            </Box>
                        ))
                    ) : (
                        <Box display="flex" justifyContent="center">
                            <SnakeLoader size="0.7rem" bg="#0170EC" distance="0.3rem" />
                        </Box>
                    )
                }
                <Box display="flex" justifyContent="flex-end" my="24px">
                    {
                        act === false ? (
                            <Box component={Button} onClick={(e) => handleSubmit(e)} variant='contained'>Submit</Box>
                        ) : (
                            <Box component={Button} onClick={(e) => handleProceed(e)} variant='contained'>Next</Box>
                        )
                    }
                </Box>
            </Box>
        </Box>
    )
}